<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Primitive, type PrimitiveProps } from 'reka-ui';
    import { type AlertVariants, alertVariants } from '.';
    import { CircleAlert, CheckCircle, XCircle, Info } from 'lucide-vue-next';
    import { computed } from 'vue';

    interface Props extends PrimitiveProps {
        variant?: AlertVariants['variant'];
        class?: HTMLAttributes['class'];
        loading?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        as: 'div',
    });

    const icon = computed(() => {
        switch (props.variant) {
            case 'success':
                return CheckCircle;
            case 'error':
                return XCircle;
            case 'info':
                return Info;
            case 'warning':
            default:
                return CircleAlert;
        }
    });
</script>

<template>
    <Primitive
        data-slot="alert"
        :as="as"
        :as-child="asChild"
        :class="cn(alertVariants({ variant }), props.class)"
    >
        <component
            :is="icon"
            class="size-6 shrink-0"
        />
        <slot />
    </Primitive>
</template>
